<script>
  import { ToastNotification } from "carbon-components-svelte";
  import LogoutIcon from "./icons/LogoutIcon.svelte";
  import UsersAddEditModal from "../../../../routes/app/settings/components/UsersAddEditModal.svelte";
  import { uiFeatureStore } from "@stores/uiFeatureStore.js";
  import SideNavFlyoutMenu from "./SideNavFlyoutMenu.svelte";
  import AdminSettingsMenu from "./AdminSettingsMenu.svelte";

  export let username = "User";
  export let email = "";
  export let onLogout = () => {};
  export let isAdmin = false;

  let open = false;
  let accountModalOpen = false;
  let toastMsg = "";
  let saveSuccessful = false;

  $: accountName = username || "User";
  $: accountInitial = accountName.trim().charAt(0).toUpperCase() || "U";

  function logout() {
    open = false;
    onLogout();
  }

  function openAccountSettings() {
    open = false;
    accountModalOpen = true;
  }
</script>

<SideNavFlyoutMenu bind:open align="bottom" ariaLabel="Open account menu" tooltip={accountName}>
  <svelte:fragment slot="trigger">
    <span class="account-avatar">{accountInitial}</span>
    <span class="account-trigger-label">{accountName}</span>
  </svelte:fragment>
  <div class="account-menu-info">
    <span class="account-avatar account-avatar-large">
      {accountInitial}
    </span>
    <div class="account-menu-text">
      <div class="account-menu-name">{accountName}</div>
      <div class="account-menu-email">{email}</div>
    </div>
  </div>
  {#if $uiFeatureStore.userMenu.showAccountSettings}
    <button class="side-nav-flyout-item" type="button" on:click={openAccountSettings}>
      <span class="account-settings-icon" aria-hidden="true" />
      <span>Account settings</span>
    </button>
  {/if}
  {#if isAdmin}
    <AdminSettingsMenu embedded onNavigate={() => (open = false)} />
  {/if}
  <button class="side-nav-flyout-item" type="button" on:click={logout}>
    <LogoutIcon />
    <span>Log out</span>
  </button>
</SideNavFlyoutMenu>

{#if accountModalOpen}
  <UsersAddEditModal
    logedUser
    accountOnly
    bind:modalOpen={accountModalOpen}
    bind:toastMsg
    bind:saveSuccessful
  />
{/if}

{#if toastMsg}
  <div class="account-toast-wrapper">
    <ToastNotification
      fullWidth
      hideAfter={saveSuccessful ? 3000 : null}
      timeout={saveSuccessful ? 3000 : null}
      kind={saveSuccessful ? "success" : "error"}
      title={saveSuccessful ? "Success" : "Error"}
      subtitle={toastMsg}
      caption={new Date().toLocaleString()}
      on:close={(event) => {
        event.preventDefault();
        toastMsg = "";
        saveSuccessful = false;
      }}
    />
  </div>
{/if}

<style>
  .account-avatar {
    align-items: center;
    background: var(--pax-black);
    border-radius: 50%;
    color: var(--pax-white);
    display: inline-flex;
    flex: 0 0 1.5rem;
    font-size: 0.75rem;
    font-weight: 600;
    height: 1.5rem;
    justify-content: center;
    line-height: 1;
    text-transform: uppercase;
    width: 1.5rem;
  }

  .account-trigger-label {
    display: none;
    font-size: 0.75rem;
    font-weight: 300;
    line-height: 0.8rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  :global(.app-side-nav.expanded) .account-trigger-label {
    display: block;
  }

  .account-menu-info {
    align-items: center;
    border-bottom: 1px solid var(--border-color);
    display: flex;
    gap: 0.75rem;
    padding: 0.75rem;
  }

  .account-avatar-large {
    flex-basis: 2rem;
    font-size: 0.875rem;
    height: 2rem;
    width: 2rem;
  }

  .account-menu-text {
    min-width: 0;
  }

  .account-menu-name {
    color: var(--pax-black);
    font-size: 0.875rem;
    font-weight: 600;
    line-height: 1.2;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .account-menu-email {
    color: var(--text-secondary, #6f6f6f);
    font-size: 0.75rem;
    line-height: 1.25;
    margin-top: 0.125rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .account-settings-icon {
    background: var(--pax-black);
    display: inline-block;
    flex: 0 0 auto;
    height: 1rem;
    mask: url("/img/assistant/icons/settings.svg") center / contain no-repeat;
    -webkit-mask: url("/img/assistant/icons/settings.svg") center / contain no-repeat;
    width: 1rem;
  }

  :global(.side-nav-flyout-item svg) {
    flex: 0 0 auto;
    height: 1rem;
    width: 1rem;
  }

  .account-toast-wrapper {
    bottom: 1rem;
    position: fixed;
    right: 1rem;
    width: min(26rem, calc(100vw - 2rem));
    z-index: 9000;
  }
</style>
